import {getPreferredNetwork} from "./util/theme/themeUtils";

/* eslint-disable no-magic-numbers */
export enum ALGORAND_CHAIN_ID {
  MAINNET = 416001,
  TESTNET = 416002
}
/* eslint-enable no-magic-numbers */

export enum NetworkToggleValue {
  MainNet = "mainnet",
  TestNet = "testnet"
}

// TODO: Change when slippage tolerance is decided
export const SWAP_SLIPPAGE = 0.01;

export const PREFERRED_NETWORK = getPreferredNetwork();

export const IS_USING_MAINNET = PREFERRED_NETWORK === NetworkToggleValue.MainNet;
export const IS_USING_TESTNET = PREFERRED_NETWORK === NetworkToggleValue.TestNet;

export const MAXIMUM_PLATFORM_FEE_PERCENTAGE = 5;
